











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class ReportAction extends Vue {
  $refs!: {
    otherReasonField: HTMLTextAreaElement;
  };
  $wlToastr: any;
  @Prop() entityId;
  @Prop() entityType;
  @Prop() isPostDetailsPage;
  private reportReason: string = '';
  private selectedReason = 1;
  private reasonDescription = '';
  private otherReasonError = '';
  private canShowReasonDescription = false;
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId && modalId.includes('report-post-modal')) {
        this.selectedReason = 1;
        this.otherReasonError = '';
      }
    });
  }
  get reportReasons() {
    return vxm.forum.ReportReasons;
  }
  get reportPostModalId() {
    return 'report-post-modal-' + this.entityId;
  }
  hideReportModal() {
    this.$root.$emit('bv::hide::modal', this.reportPostModalId);
  }
  async reportPost(postId) {
    if (this.canShowReasonDescription && !this.reasonDescription) {
      this.otherReasonError = 'Reason is required';
      this.$refs.otherReasonField.focus();
      return;
    }
    this.otherReasonError = '';
    const response = await vxm.forum.reportPost({
      reportedEntityId: postId,
      forumReportReasonCodeId: this.selectedReason,
      reportedEntityType: this.entityType,
      reportedReasonDescription: this.reasonDescription,
    });
    this.$wlToastr('success', response.data.successMessage);
    this.hideReportModal();
    if (this.isPostDetailsPage) {
      if (this.entityType === 2) {
        vxm.forum.listComments({
          postId: this.$route.params.postId,
          initCall: true,
        });
        vxm.forum.fetchPostDetails(this.$route.params.postId);
      }
      this.entityType === 1 && this.$router.push({ name: 'Forum' });
      return;
    }
    vxm.forum.loadPosts({ initCall: true });
  }
  onSelectReason(event) {
    const selectedReason = this.getSelectedReasonInfo(
      Number(event.target.value),
    );
    this.canShowReasonDescription =
      selectedReason && selectedReason.isAdditionalInfoRequired;
  }

  getSelectedReasonInfo(reasonId) {
    const selectedReason = this.reportReasons.find((reason) => {
      return reason.forumReportReasonCodeId === Number(reasonId);
    });
    return selectedReason;
  }
}
